import { RequestLog } from '@engine/models'

import { ActivityTimeline } from '#components/ActivityTimeline'
import { EmptyState } from '#components/EmptyState'
import { ErrorsSection } from '#components/ErrorsSection'
import { KeyValueDisplay } from '#components/KeyValueDisplay'
import { RequestLogSections } from '#components/RequestLogSections'
import { formatDateTime } from '#utils/format'

import { EbolStatusBadge } from './EbolStatusBadge'

interface EbolDetailsProps {
  ebol: RequestLog | null
}

const EbolDetails = ({ ebol }: EbolDetailsProps) => {
  if (!ebol) {
    return <EmptyState title="Select an eBOL to view details" />
  }

  const responseContent = ebol.tenantResponse?.content as any
  const errorType = responseContent?.errorType
  const errors = responseContent?.errors

  return (
    <div className="space-y-6">
      {/* Overview Section */}
      <KeyValueDisplay
        items={[
          { label: 'External ID', value: ebol.externalId },
          { label: 'Request ID', value: ebol.requestId },
          { label: 'Tenant ID', value: ebol.tenantId },
          { label: 'Type', value: ebol.type },
          {
            label: 'Carrier',
            value:
              ebol.carrierCode?.[0] ||
              ebol.serviceRequest?.[0].content?.providerCode ||
              'N/A',
          },
          {
            label: 'Request Date',
            value: formatDateTime(ebol.tenantRequest?.requestDate),
          },
          {
            label: 'Status',
            value: <EbolStatusBadge log={ebol} />,
          },
          ...(errorType ? [{ label: 'Error Type', value: errorType }] : []),
        ]}
      />

      {/* Errors Section */}
      <ErrorsSection
        errors={errors}
        errorType={errorType}
        carrier={ebol.carrierCode?.[0]}
        requestId={ebol.requestId}
        externalId={ebol.externalId}
        service="ebol"
      />

      <RequestLogSections requestLog={ebol} />

      {/* Activity Timeline */}

      <ActivityTimeline
        externalId={ebol.externalId}
        emptyMessage="No traces or request logs found for this eBOL."
      />
    </div>
  )
}

export { EbolDetails }
